export const Logo = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <rect x="1.5" y="1.5" width="45" height="45" fill="#102A43" stroke="#1769AA" strokeWidth="1.5" />
    <path d="M24 6v8M24 34v8M6 24h8M34 24h8" stroke="#5AA9E6" strokeWidth="1.5" />
    <circle cx="24" cy="24" r="9" fill="none" stroke="#5AA9E6" strokeWidth="1.2" />
    <path d="M11 35 L20 27 L29 30 L37 14" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinejoin="miter" />
    <rect x="34.5" y="11.5" width="5" height="5" fill="#D8B66A" />
    <circle cx="11" cy="35" r="1.8" fill="#D8B66A" />
  </svg>
);

export const Wordmark = ({ dark = true }) => (
  <span className="flex items-center gap-2.5 sm:gap-3">
    <Logo className="h-9 w-9 shrink-0" />
    <span className="leading-none whitespace-nowrap">
      <span className={`block font-display text-[14px] sm:text-[15px] font-extrabold tracking-[0.14em] sm:tracking-[0.18em] ${dark ? "text-white" : "text-[#102A43]"}`}>GEO DRAFTING</span>
      <span className={`block font-mono text-[9px] tracking-[0.12em] mt-1 ${dark ? "text-[#9fb3c8]" : "text-[#526579]"}`}>COORDINATES → CAD</span>
    </span>
  </span>
);
